"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSafeWindowOffset = exports.getViewport = exports.isMobileApp = exports.isMobileWeb = exports.isMobile = exports.isDesktop = void 0;
/**
 * Determine if the application is currently being rendered in a non-mobile browser.
 */
exports.isDesktop = function () {
    return !exports.isMobileApp() && !exports.isMobileWeb();
};
/**
 * Determines if the application is running in either a mobile browser, or the mobile app.
 */
exports.isMobile = function () {
    return exports.isMobileApp() || exports.isMobileWeb();
};
/**
 * Determines if the application is currently being on a mobile device, but not within within the mobile app.
 */
exports.isMobileWeb = function () {
    var userAgent = typeof window !== 'undefined' && window.navigator.userAgent.toLowerCase();
    return (!exports.isMobileApp() && /(iphone|ipad|mobile)/.test(userAgent));
};
/**
 * Determines if the application is currently being rendered within the mobile app.
 */
exports.isMobileApp = function () {
    var userAgent = typeof window !== 'undefined' && window.navigator.userAgent.toLowerCase();
    return /epcmobile/.test(userAgent);
};
/**
 * Gets the browser viewport dimensions.  When the window object is not available, the `height` and
 * `width` properties will reflect values of zero.
 */
exports.getViewport = function () {
    if (typeof window !== 'undefined') {
        return {
            width: Math.max(window.document.documentElement.clientWidth, window.innerWidth || 0),
            height: Math.max(window.document.documentElement.clientHeight, window.innerHeight || 0)
        };
    }
    return { width: 0, height: 0 };
};
/**
 * Determines safe min/max window offset value of an absolutely positioned element
 * to prevent the absolutely positioned element to break outside of the left/right
 * edges of the viewport
 *
 * @param el DOM element to be absolutely positioned
 * @param offset Offset value (right or left) to be safe-checked
 * @return Safe offset value (px)
 */
exports.getSafeWindowOffset = function (el, offset) {
    var viewportWidth = exports.getViewport().width;
    if (offset < 0) {
        return 0;
    }
    else if (offset + el.offsetWidth > viewportWidth) {
        return viewportWidth - el.offsetWidth;
    }
    return offset;
};
